import { useEffect, useState } from "react";
import { FileText, Loader2 } from "lucide-react";
import { useApi } from "@/lib/api";

export function useFileUrl(fileId) {
  const api = useApi();
  const [file, setFile] = useState(null);
  useEffect(() => {
    if (!fileId) return;
    let url;
    let alive = true;
    api.get(`/files/${fileId}`, { responseType: "blob" }).then((r) => {
      url = URL.createObjectURL(r.data);
      if (alive) setFile({ url, type: r.data.type });
    }).catch(() => alive && setFile({ error: true }));
    return () => {
      alive = false;
      if (url) URL.revokeObjectURL(url);
    };
  }, [fileId, api]);
  return file;
}

export function SecureFile({ fileId, alt, className = "", testId }) {
  const f = useFileUrl(fileId);
  if (!fileId) return <div className={`grid place-items-center bg-white/5 text-xs text-neutral-500 ${className}`}>Not uploaded</div>;
  if (!f) return <div className={`grid place-items-center bg-white/5 ${className}`}><Loader2 className="h-5 w-5 animate-spin text-neutral-500" /></div>;
  if (f.error) return <div className={`grid place-items-center bg-white/5 text-xs text-rose-400 ${className}`}>Could not load</div>;
  if (f.type === "application/pdf")
    return (
      <a href={f.url} target="_blank" rel="noreferrer" data-testid={testId} className={`grid place-items-center gap-1 bg-white/5 text-xs text-[#FF5A00] ${className}`}>
        <FileText className="h-8 w-8" />Open PDF
      </a>
    );
  return (
    <a href={f.url} target="_blank" rel="noreferrer" data-testid={testId}>
      <img src={f.url} alt={alt} className={`object-cover ${className}`} />
    </a>
  );
}
